import { useTranslation } from "react-i18next";
import { useSuccessRatePerTopic } from "../hooks/useSuccessRatePerTopic";
import Part2KpiCards from "./part2-kpi-cards";
import SuccessRatePerTopic from "./success-rate-per-topic";
import { TopLeastUnderstoodThemes, TopPopularThemes } from "./top-themes-stats";

const Part2StatsSection = () => {
  const { t } = useTranslation();

  // Topic success rates come from the topics list (all-time, no date filter).
  const { data: successRate, isLoading } = useSuccessRatePerTopic();
  const topicStats = successRate ?? [];

  return (
    <section className="flex flex-col gap-4 border-t pt-6 mt-2">
      <p className="font-semibold">{t("modules.stats.part2.title")}</p>
      <Part2KpiCards />
      <SuccessRatePerTopic data={topicStats} isLoading={isLoading} />
      <div className="flex flex-col lg:flex-row items-stretch gap-4">
        <TopPopularThemes />
        <TopLeastUnderstoodThemes />
      </div>
    </section>
  );
};

export default Part2StatsSection;
